"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fx_1 = require("../../lib/fx");
const wa_1 = require("../../lib/wa");
class PfmStat extends React.Component {
    componentDidMount() {
        document.addEventListener('local:load', (event) => {
            const data = event.data;
            const pfmData = this.onPerformance(data);
            wa_1.WaPerformance.setCommonParams(pfmData);
            wa_1.WaPerformance.log({
                ev_ct: 'performance',
            });
        });
        const ucweb = window.ucweb;
        if (ucweb) {
            ucweb.window.addEventListener('BacktracePaintReady', () => {
                const time = ucweb.window.performance;
                wa_1.WaPerformance.log({
                    ev_ct: 'u4Pfm',
                    new_t0: time.t0,
                    new_t1: time.t1,
                    new_t2: time.t2,
                    new_t3: time.t3,
                });
            });
        }
        fx_1.sendEvent('pfm:init', {});
    }
    render() {
        return null;
    }
    getFsImgCount() {
        try {
            const screenHeigt = window.innerHeight;
            const bodyRect = document.body.getBoundingClientRect();
            const imgs = document.querySelectorAll('img');
            let fsImgCount = 0;
            imgs.forEach((img) => {
                const top = img.getBoundingClientRect().top - bodyRect.top;
                if (top < screenHeigt) {
                    fsImgCount++;
                }
            });
            return fsImgCount;
        }
        catch (ex) {
            return -1;
        }
    }
    onPerformance(extra) {
        const timing = performance && performance.timing;
        const navigation = performance && performance.navigation;
        // 重定向次数
        const redirectCount = navigation && navigation.redirectCount;
        if (!timing || timing.requestStart === 0 || timing.responseStart === 0) {
            return;
        }
        // 跳转耗时
        const redirect = timing.redirectEnd - timing.redirectStart;
        // APP CACHE 耗时, 或 fetchTime 没什么价值，也没有优化的可能性存在
        const appcache = Math.max(timing.domainLookupStart - timing.fetchStart, 0);
        // DNS 解析耗时
        const dns = timing.domainLookupEnd - timing.domainLookupStart;
        // TCP 链接耗时
        const conn = timing.connectEnd - timing.connectStart;
        // 等待服务器响应耗时，存在 cache 时，UC 浏览器获取的 requestStart / responseStart 为小于 13 位的数
        let request = timing.responseStart - timing.requestStart;
        // 过滤结果大于 8 位数或小于 0 的值
        request = request > 10000000 || request < 0 ? 0 : request;
        // 内容加载耗时，存在 cache 时，UC 浏览器获取的 responseStart 为小于 13 位的数
        let response = timing.responseEnd - timing.responseStart;
        response = response > 10000000 || response < 0 ? 0 : response;
        // 总体网络交互耗时，即开始跳转到服务器资源下载完成
        const network = timing.responseEnd - timing.navigationStart;
        // 渲染处理
        const processing = (timing.domComplete || timing.domLoading) - timing.domLoading;
        // 总耗时
        let total = (timing.loadEventEnd || timing.loadEventStart || timing.domComplete || timing.domLoading) - timing.navigationStart;
        // 可交互
        const active = timing.domInteractive - timing.navigationStart;
        // 请求响应耗时，即 T0，存在 cache 时，UC 浏览器获取的 requestStart / responseStart 为小于 13 位的数
        let t0 = timing.responseStart - timing.navigationStart;
        t0 = t0 < 0 ? 0 : t0;
        // 首次出现内容，即 T1
        const t1 = timing.domLoading - timing.navigationStart;
        // 内容加载完毕，即 T3
        let t3 = timing.loadEventStart - timing.navigationStart;
        if (extra && extra.finishedTime && extra.finishedTime > 0) {
            t3 = extra.finishedTime - timing.navigationStart;
        }
        if (t3 > total) {
            total = t3;
        }
        const firstScreen = performance.now();
        const url = window.location.href || '';
        const result = {
            redirect,
            appcache,
            dns,
            conn,
            request,
            response,
            processing,
            network,
            total,
            active,
            redirectCount,
            firstScreen: performance.now(),
            t0,
            t1,
            t2: firstScreen,
            t3: t3 < 0 ? 0 : t3,
            localPage: !!window.IS_LOCAL_PAGE,
            isPush: url.indexOf('entry1=push') !== -1 && url.indexOf('uc_biz_str=') !== -1,
            itemId: fx_1.getArticleId(),
            fsImgCount: this.getFsImgCount(),
        };
        if (extra) {
            for (const key in extra) {
                if (extra[key] !== undefined) {
                    result[key] = extra[key];
                }
            }
        }
        for (const key in result) {
            if (typeof result[key] === 'number') {
                try {
                    // tslint:disable-next-line:no-construct
                    result[key] = new Number(result[key]).toFixed(0);
                }
                catch (e) {
                    //
                }
            }
        }
        return result;
    }
}
exports.default = PfmStat;
//# sourceMappingURL=data:application/json;base64,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